export type ChatComposerStatus = 'error' | 'ready' | 'streaming' | 'submitted';

export function isChatComposerLocked(params: {
  isAskUserSubmitting: boolean;
  quotaBlocked?: boolean;
  status: ChatComposerStatus;
}) {
  return params.status === 'submitted'
    || params.status === 'streaming'
    || params.isAskUserSubmitting
    || params.quotaBlocked === true;
}

/**
 * A composer attachment is "pending" while its upload (and server-side
 * extraction) has not settled. Sending must wait for these to resolve,
 * otherwise the file is silently dropped from the outgoing message.
 */
export function hasPendingComposerAttachments(
  attachments: ReadonlyArray<{ status: string }>,
): boolean {
  return attachments.some(
    (attachment) => attachment.status === 'uploading' || attachment.status === 'extracting',
  );
}
